import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//imports atomic components

import { HomeComponent } from './home/home.component';
import { NosotrosComponent } from './nosotros/nosotros.component';
import { ContactoComponent } from './contacto/contacto.component';
import { InstitucionalComponent } from './institucional/institucional.component';
import { PicoyplacaComponent } from './picoyplaca/picoyplaca.component';
import { TarifasComponent } from './tarifas/tarifas.component';
import { EstadoViaComponent } from './estado-via/estado-via.component';
import { OrganismsModule } from '../02-organisms/organisms.module';

import { AtomsModule } from '../00-atoms/atoms.module';
import { MoleculesModule } from '../01-molecules/molecules.module';
import { ServiciosComponent } from './servicios/servicios.component';
import { NoticiasComponent } from './noticias/noticias.component';
import { NoticiaComponent } from './noticia/noticia.component';
import { RouterModule } from '@angular/router';
import { ImporteComponent } from './importe/importe.component';
import { DocumentoEquivalenteComponent } from './documento-equivalente/documento-equivalente.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    HomeComponent,
    NosotrosComponent,
    ContactoComponent,
    InstitucionalComponent,
    PicoyplacaComponent,
    ServiciosComponent,
    TarifasComponent,
    EstadoViaComponent,
    NoticiasComponent,
    NoticiaComponent,
    ImporteComponent,
    DocumentoEquivalenteComponent,
  ],
  imports: [
    CommonModule,
    AtomsModule,
    OrganismsModule,
    MoleculesModule,
    RouterModule,
    ReactiveFormsModule
  ],
  exports: [
    HomeComponent,
    NosotrosComponent,
    ContactoComponent,
    InstitucionalComponent,
    PicoyplacaComponent,
    ServiciosComponent,
    TarifasComponent,
    EstadoViaComponent,
    NoticiasComponent,
    NoticiaComponent,
    ImporteComponent,
  ],
  entryComponents: [
    HomeComponent,
    NosotrosComponent,
    ContactoComponent,
    InstitucionalComponent,
    PicoyplacaComponent,
    ServiciosComponent,
    TarifasComponent,
    EstadoViaComponent,
    NoticiasComponent,
    NoticiaComponent,
    ImporteComponent,
  ],
})
export class PagesModule { }
